import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "quill/dist/quill.core.css"
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'dayjs/locale/zh-cn'
import locale from 'element-plus/es/locale/lang/zh-cn'

createApp(App)
    .use(ElementPlus,{locale})
    .use(store)
    .use(router)
    .mount('#app')
